export default __webpack_public_path__ + "static/media/TEXTURA_05.7a85d1bf.png";